import axios from "axios";

export default {
    fetchStudyProduct(id) {
        return axios.get('study-products/' + id + '?expand=courses,subscriptions')
            .then(response => {
                return response.data
            })
    },

    fetchStudyProductSlug(slug) {
        return axios.get('study-products/by-slug/' + slug + '?expand=courses,subscriptions')
            .then(response => {
                return response.data
            })
    },

    fetchStudyProducts() {
        return axios.get('study-products?expand=courses,subscriptions')
            .then(response => {
                return response.data
            })
    },

}
